<script lang="ts" setup>
import TheHeaderDesktop from '@/components/Header/TheHeaderDesktop.vue'
import TheHeaderMobile from '@/components/Header/TheHeaderMobile.vue'

const emit = defineEmits(['on-toggle-navigation'])

const onToggleNavigation = (state: boolean) =>
  emit('on-toggle-navigation', state)

const { isDesktop } = useResponsive()
</script>

<template>
  <the-header-desktop v-if="isDesktop" />

  <the-header-mobile v-else @on-toggle-navigation="onToggleNavigation" />
</template>
